
























import { Component, Prop, Vue } from 'vue-property-decorator'
import RadioButton from '@/app/ui/components/RadioButton/index.vue'

@Component({
  inheritAttrs: false,
  components: { RadioButton },
})
export default class MarketplaceRadioButton extends Vue {
  @Prop({ required: true }) private fieldLabel!: string
  @Prop({ default: false }) private required!: boolean
  @Prop({ default: () => [] }) private options!: Array<Map<string, unknown>>

  changeValue(val: string): void {
    this.$emit('input', val)
  }
}
